import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CharterNotificationsPage } from './charter-notifications.page';

const routes: Routes = [
  {
    path: '',
    component: CharterNotificationsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)]
})
export class CharterNotificationsPageRoutingModule {}
